import { Avatar, Card, CardActions, CardContent, CardHeader, Switch, Typography, withStyles } from "@material-ui/core";
import _ from 'lodash';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ActionButtons from "../../../common/components/UI/ActionButtons/ActionButtons";
import SimpleDialog from "../../../common/components/UI/Dialog/SimpleDialog";
import InputNumber from "../../../common/components/UI/Input/Number";
import RadioButton from "../../../common/components/UI/RadioGroup/RadioButton";
import ReactSelect from "../../../common/components/UI/Select/ReactSelect";
import Snackbar from "../../../common/components/UI/Snackbar/Snackbar";
import SettingTitle from '../../../common/components/UI/Title/SettingTitle';
import { currentHttpOptions } from "../../utils";
import { defaultConfigs } from './GlobalConfigurations.service';

import {
    AdminGlobalSetupSectionNames,
    AdminGlobalSetupSections,
    PostedRequestDisplay,
    getGlobalConfigParamsToUpdate,
    getGlobalConfigurations,
    initialStateGlobalConfigurations,
    updateGlobalConfiguration,
} from './GlobalConfigurations.service';

import './GlobalConfigurations.scss';

const styles = () => ({
    buttonSection: {
        display: 'block',
        padding: '0',
    }
});

/**
 * @typedef {import('./GlobalConfigurations.service').IOnSuccess} IOnSuccess
 * @typedef {import('./GlobalConfigurations.service').IOnError} IOnError
 */

class ArchivingRules extends Component {
    constructor(props) {
        super(props);
        this.state = initialStateGlobalConfigurations;
        this.init();
    }

    init = () => {
        const options = currentHttpOptions();

        /** @type {IOnSuccess} */
        const onSuccess = (loadedConfigs) => this.setState(loadedConfigs);
        getGlobalConfigurations(options, onSuccess, this.displaySnackBarError);
    }

    submitAction = () => {
        const { configs, unchangedConfigs, confirmModelSection } = this.state;
        const options = currentHttpOptions();

        const configParamsToUpdate = getGlobalConfigParamsToUpdate(
            unchangedConfigs,
            confirmModelSection,
            AdminGlobalSetupSections,
            AdminGlobalSetupSectionNames,
            configs,
        );

        if (!configParamsToUpdate) {
            return;
        }

        const {
            route,
            data,
            globalConfigToUpdate,
        } = configParamsToUpdate;

        const reponseFct = this.setState(globalConfigToUpdate);

        updateGlobalConfiguration(route, data, options, reponseFct, this.displaySnackBarError);
        this.closeModal();
    }

    discardAction = (section) => { //reset value
        let configs = { ...this.state.configs };
        if (section === AdminGlobalSetupSections.archiving) {
            configs.archiving = { ...this.state.unchangedConfigs.archiving };
        }

        if (section === AdminGlobalSetupSections.displayPreferences) {
            configs.displayPreferences = { ...this.state.unchangedConfigs.displayPreferences };
        }

        if (section === AdminGlobalSetupSections.employeeReports) {
            configs.employeeReports = { ...this.state.unchangedConfigs.employeeReports };
        }

        if (section === AdminGlobalSetupSections.shiftSwapSetup) {
            configs.shiftSwapSetup = { ...this.state.unchangedConfigs.shiftSwapSetup };
        }

        this.setState({ configs });
    }

    openModal = (section) => {
        const { t } = this.props
        let modalText = t('global.confirmModalContent');
        if(section === AdminGlobalSetupSections.shiftSwapSetup){
            modalText = t('shiftSwapSetup.confirmShiftSwapSetupSection');
        }

        this.setState({
            showConfirmModal: true,
            modalText,
            confirmModelSection: section,
        });
    }
    closeModal = () => {
        this.setState({
            showConfirmModal: false,
            confirmModelSection: '',
        })
    }

    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    displaySnackBarError = (/** @type {string} */ message) => this.handleSnackbar('error', message, true);

    closeSnackbar = () => {
        setTimeout(() => {
            this.setState({ openSnackbar: false });
        }, 5000)
    }

    render() {
        const { t, classes } = this.props
        const { configs, unchangedConfigs, showConfirmModal, messageSnackbar, typeSnackbar, openSnackbar, modalText } = this.state;

        const isArchiveValueUnchanged = _.isEqual(configs.archiving, unchangedConfigs.archiving);
        const isDisplayValueUnchanged = _.isEqual(configs.displayPreferences, unchangedConfigs.displayPreferences);
        const isAllEmployeeOffersViewChanged = _.isEqual(configs.employeeReports, unchangedConfigs.employeeReports);
        const isShiftSwapSetupChanged = _.isEqual(configs.shiftSwapSetup, unchangedConfigs.shiftSwapSetup);

        const calendarMonthOptions = [...Array(7).keys()].map((x) => ({
            label: `${t('shiftSwapSetup.calendarMonthOptionsPrefix')}${x ? ` +${x}` : ''}`,
            value: x
        }));

        let stepNumber = 1;

        return (
            <section className="global-configurations">
                <SettingTitle
                    subtitleText={t('settings.settings')}
                    titleText={t('settings.appName')}
                    reverse={true}
                />
                <hr />

                <div className="cards-container">
                    {/* Manager section */}
                    <div className="section-title">
                        <Typography className="section-title" variant="h6" display="block" >
                            {t('global.sectionTitles.manager')}
                        </Typography>
                    </div>
                    <Card className="gc-cards">
                        <CardHeader
                            className="gc-card-header"
                            color="textSecondary"
                            gutterBottom
                            avatar={
                                <Avatar className="gc-step-avatar">{stepNumber}</Avatar>
                            }
                            title={t('archive.header')}
                        />
                        <CardContent className="gc-card-content">
                            <Typography className="section-title" variant="h6" display="block" >
                                {t('archive.title')}
                            </Typography>

                            <InputNumber
                                min={0}
                                max={9999}
                                step={1}
                                precision={0}
                                value={configs.archiving.archiveInactiveDays}
                                strict={true}
                                handleChangeInput={(value) => {
                                    configs.archiving.archiveInactiveDays = value;
                                    this.setState({ configs: configs })
                                }}>
                            </InputNumber>
                            <div className="disclaimer">{t('archive.disclaimer')}</div>
                        </CardContent>
                        <CardActions disableSpacing>
                            <ActionButtons
                                submit={() => this.openModal(AdminGlobalSetupSections.archiving)}
                                cancel={() => this.discardAction(AdminGlobalSetupSections.archiving)}
                                submitText={t('global.confirm')}
                                cancelText={t('global.discard')}

                                classes={classes}
                                disabledSubmit={isArchiveValueUnchanged}
                                disabledCancel={isArchiveValueUnchanged}
                            />
                        </CardActions>
                    </Card>

                    {/* Employee section */}
                    <div className="section-title">
                        <Typography className="section-title" variant="h6" display="block" >
                            {t('global.sectionTitles.employee')}
                        </Typography>
                    </div>
                    <Card className="gc-cards">
                        <CardHeader
                            className="gc-card-header"
                            color="textSecondary"
                            gutterBottom
                            avatar={
                                <Avatar className="gc-step-avatar">{++stepNumber}</Avatar>
                            }
                            title={t('displaySettings.header')}
                        />
                        <CardContent className="gc-card-content">
                            <Typography className="section-title" variant="h6" display="block" >
                                {t('displaySettings.pathLength.title')}
                            </Typography>
                            <InputNumber
                                min={0}
                                max={9999}
                                step={1}
                                precision={0}
                                value={configs.displayPreferences.lastVisibleOrgPathLength}
                                strict={true}
                                handleChangeInput={(value) => {
                                    configs.displayPreferences.lastVisibleOrgPathLength = value;
                                    this.setState({ configs: configs })
                                }}>
                            </InputNumber>
                            <div className="disclaimer">{t('displaySettings.pathLength.disclaimer')}</div>

                            <div className="calendar-request--wrapper">
                                <Typography className="section-title" variant="h6" display="block" >
                                    {t('displaySettings.calendarPreferences.title')}
                                </Typography>
                                <div className="calendar-request--posted-request">
                                    <span>{t('displaySettings.calendarPreferences.postedRequest.title')}</span>
                                    <RadioButton
                                        GroupClass="radio-global-config"
                                        valueRadioGroup={configs.displayPreferences.postedRequestDisplay}
                                        onChange={(event) => {
                                            configs.displayPreferences.postedRequestDisplay = parseInt(event.target.value);
                                            this.setState({ configs: configs });
                                        }}
                                        labelA={t('displaySettings.calendarPreferences.postedRequest.showRequestName')}
                                        valueA={PostedRequestDisplay.requestName}
                                        labelB={t('displaySettings.calendarPreferences.postedRequest.showShiftTime')}
                                        valueB={PostedRequestDisplay.shiftTime}
                                    />
                                </div>
                            </div>

                            <hr />

                            <div className="show-organizational-path--wrapper">
                                <div className="show-organizational-path--toggle">
                                    <Switch
                                        checked={configs.displayPreferences.isShowOrganizationalPath}
                                        onChange={event => {
                                            configs.displayPreferences.isShowOrganizationalPath = event.target.checked;
                                            this.setState({ configs: configs });
                                        }}
                                        color="primary"
                                    />
                                    <label>{t('displaySettings.calendarPreferences.isShowOrganizationalPath.title')}</label>
                                </div>
                                <div className="disclaimer">{t('displaySettings.calendarPreferences.isShowOrganizationalPath.disclaimer')}</div>
                            </div>
                        </CardContent>
                        <CardActions>
                            <ActionButtons
                                submit={() => this.openModal(AdminGlobalSetupSections.displayPreferences)}
                                cancel={() => this.discardAction(AdminGlobalSetupSections.displayPreferences)}
                                submitText={t('global.confirm')}
                                cancelText={t('global.discard')}

                                classes={classes}
                                disabledSubmit={isDisplayValueUnchanged}
                                disabledCancel={isDisplayValueUnchanged}
                            />
                        </CardActions>
                    </Card>

                    <Card className="gc-cards">
                        <CardHeader
                            className="gc-card-header"
                            color="textSecondary"
                            gutterBottom
                            avatar={
                                <Avatar className="gc-step-avatar">{++stepNumber}</Avatar>
                            }
                            title={t('employeeReports.header')}
                        />
                        <CardContent className="gc-card-content">
                            <Switch
                                checked={configs.employeeReports.isAllEmployeeOffersEnabled}
                                onChange={({ target: { checked } }) => {
                                    configs.employeeReports.isAllEmployeeOffersEnabled = checked;
                                    this.setState({ configs: configs });
                                }}
                                color="primary"
                            />
                            <label>{t('employeeReports.isAllEmployeeOffersEnabled')}</label>
                        </CardContent>
                        <CardActions>
                            <ActionButtons
                                submit={() => this.openModal(AdminGlobalSetupSections.employeeReports)}
                                cancel={() => this.discardAction(AdminGlobalSetupSections.employeeReports)}
                                submitText={t('global.confirm')}
                                cancelText={t('global.discard')}

                                classes={classes}
                                disabledSubmit={isAllEmployeeOffersViewChanged}
                                disabledCancel={isAllEmployeeOffersViewChanged}
                            />
                        </CardActions>
                    </Card>
                    <Card className="gc-cards">
                        <CardHeader
                            className="gc-card-header"
                            color="textSecondary"
                            gutterBottom
                            avatar={
                                <Avatar className="gc-step-avatar">{++stepNumber}</Avatar>
                            }
                            title={t('shiftSwapSetup.header')}
                        />
                        <CardContent className="gc-card-content">
                            <Switch
                                checked={configs.shiftSwapSetup.overrideMonthsInFuture}
                                onChange={({ target: { checked } }) => {
                                    configs.shiftSwapSetup.overrideMonthsInFuture = checked;
                                    if(!checked){
                                        configs.shiftSwapSetup.requestPeriodNumberOfMonthsInFuture = defaultConfigs.shiftSwapSetup.requestPeriodNumberOfMonthsInFuture;
                                    }
                                    this.setState({ configs: configs });
                                }}
                                color="primary"
                            />
                            <label>{t('shiftSwapSetup.overrideMonthsInFuture')}</label>
                            <div style={{maxWidth: "500px"}}>
                                <ReactSelect
                                    isDisabled={!configs.shiftSwapSetup.overrideMonthsInFuture}
                                    labelText={t('shiftSwapSetup.calendarMonth')}
                                    options={calendarMonthOptions}
                                    value={calendarMonthOptions.find(x => x.value === configs.shiftSwapSetup.requestPeriodNumberOfMonthsInFuture)}
                                    onChange={(target, value) => {
                                        configs.shiftSwapSetup.requestPeriodNumberOfMonthsInFuture = value.value;
                                        this.setState({ configs: configs });
                                    }}
                                    note={t('shiftSwapSetup.calendarMonthDisclaimer')}
                                />
                            </div>
                            

                        </CardContent>
                        <CardActions>
                            <ActionButtons
                                submit={() => this.openModal(AdminGlobalSetupSections.shiftSwapSetup)}
                                cancel={() => this.discardAction(AdminGlobalSetupSections.shiftSwapSetup)}
                                submitText={t('global.confirm')}
                                cancelText={t('global.discard')}

                                classes={classes}
                                disabledSubmit={isShiftSwapSetupChanged}
                                disabledCancel={isShiftSwapSetupChanged}
                            />
                        </CardActions>
                    </Card>
                </div>

                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={this.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                <SimpleDialog
                    open={showConfirmModal}
                    title={t('global.confirm')}
                    contentText={modalText}
                    submit={this.submitAction}
                    cancel={this.closeModal}
                />
            </section>
        );
    }
}

export default withStyles(styles)(withTranslation(['globalConfigurations'])(ArchivingRules));

